<template>
    <modal
        :adaptive="true"
        :class="{ 'mobile-item-modal': pivotY === 1 }"
        :clickToClose="true"
        :maxWidth="575"
        :pivotY="pivotY"
        :reset="true"
        :scrollable="true"
        class="modal-visible-overflow"
        height="auto"
        name="cross-sell-modal"
        transition="pop-out"
        width="575"
        @opened="opened()"
        @before-open="onBeforeOpen"
        @before-close="onBeforeClose"
    >
        <div class="w-full bg-secondary mt-20 rounded-md">
            <div class="modal-body">
                <div
                    class="sticky top-0 z-50 flex w-full bg-secondary py-3 px-4 shadow-sm rounded-t-md"
                >
                    <h2 class="font-heading text-xl font-bold text-subheading">
                        {{ $t('crossSellModal.peopleAlsoAdded') }}
                    </h2>
                    <div class="absolute right-0 top-0 pr-3 pt-3">
                        <button
                            aria-label="Hide basket"
                            class="text-primary transition duration-150 ease-in-out hover:text-gray-500 focus:text-gray-500 focus:outline-none"
                            type="button"
                            @click="continueToCheckout"
                        >
                            <close-icon />
                        </button>
                    </div>
                </div>
                <div class="relative pt-4">
                    <ul>
                        <menu-item
                            v-for="item in products"
                            :key="item.id"
                            :image-size="'md'"
                            :isAvailable="isInStock(item)"
                            :item="item"
                            :large-images="largeImages"
                            :quick-add="true"
                            :source="'cross_sell_quick_add'"
                            class="!flex-row"
                            @click.native="showItemModal(item)"
                        />
                    </ul>
                </div>
                <div class="z-50 sticky bottom-0 flex footer-blurred p-3">
                    <button
                        class="border-button-primary no-highlight w-full flex-auto select-none clip-path-button rounded-button rounded-sm bg-button font-button px-12 py-4 text-center text-sm font-bold text-button shadow sm:mb-3 md:mb-0 md:ml-6"
                        @click="continueToCheckout"
                    >
                        {{ $t('crossSellModal.continueToCheckout') }}
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import isMobile from '@/helpers/isMobileDevice';
import { mapActions, mapGetters, mapState } from 'vuex';
import MenuItem from '@/components/MenuItem.vue';
import CloseIcon from '@/components/icons/CloseIcon';
import { TrackingEventsEnum } from '@/enums';

export default {
    name: 'cross-sell-modal',
    components: {
        MenuItem,
        CloseIcon
    },
    props: {
        products: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            hasAddedProduct: false,
            openAsMobile: false
        };
    },
    computed: {
        ...mapState({
            cartItems: state => state.cart.items,
            largeImages: state => state.venue.venue.largeImages,
            imageSize: state => state.venue.venue.imageSize
        }),
        ...mapGetters({
            cartItemQuantity: 'cart/cartItemQuantity'
        }),
        pivotY() {
            return isMobile() ? 1 : 0.5;
        },
        isMobile() {
            return isMobile();
        }
    },
    methods: {
        ...mapActions({
            setShowMobileBasket: 'basket/setShowMobileBasket'
        }),
        showItemModal(item) {
            if (this.isInStock(item)) {
                this.$modal.show('item-modal', { item: item });
            }
        },
        continueToCheckout() {
            this.openAsMobile
                ? this.setShowMobileBasket(true)
                : this.$router.push({ name: 'checkout' });
            this.close();
        },
        isInStock(item) {
            if (item.snooze) return false;
            if (item.isAvailable && !item.trackInventory) return true;
            if (!item.isAvailable && !item.trackInventory) return false;

            if (item.trackInventory) {
                const cartQuantity = this.cartItemQuantity(item.id);
                return item.inventory - cartQuantity > 0;
            }
            return false;
        },
        update() {
            this.close();
        },
        close() {
            this.$modal.hide('cross-sell-modal');
        },
        opened() {
            if (this.$analytics) {
                const crossSellType = this.$store.state.venue.venue
                    .upsellProducts
                    ? 'product'
                    : 'category';
                this.$analytics.track(
                    TrackingEventsEnum.CROSS_SELL_MODAL_VIEW,
                    {
                        productCount: this.products.length,
                        crossSellType
                    }
                );
            }
        },
        onBeforeOpen({ params }) {
            const isMobile = params.isMobile;
            this.openAsMobile = isMobile;
            document.body.classList.add('v--modal-cross-sell-block-scroll');
        },
        onBeforeClose() {
            document.body.classList.remove('v--modal-cross-sell-block-scroll');
        }
    }
};
</script>
